var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "manage-menu-popup"
  }, [_c('b-modal', {
    attrs: {
      "id": "manageMenu",
      "centered": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "manage-menu-popup-header text-center"
        }, [_c('h4', [_vm._v("Manage Menu")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "manage-menu-popup-form"
  }, [_c('input-text', {
    attrs: {
      "label-name": "Title",
      "label-for": "title",
      "vmodel": _vm.form.name,
      "form-group-class": "form-group mb-3",
      "input-class": "custom-input",
      "rules": {
        required: true
      },
      "readonly": true,
      "api-errors": _vm.apiErrors
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.form, "name", $event);
      }
    }
  }), _c('label', [_vm._v("Select Reps "), _vm.showSpinner ? _c('span', [_c('spinner-grow', {
    attrs: {
      "styles": _vm.spinnerStyles
    }
  })], 1) : _c('span', {
    staticClass: "clr-theme"
  }, [_vm._v("( " + _vm._s("".concat(_vm.sendRepMessageSelectedReps.length, " ").concat(_vm.sendRepMessageSelectedReps.length > 0 ? "Rep's" : "Rep", " Selected")) + " )")])]), _c('rep-tree', {
    attrs: {
      "downline-list": _vm.downlineList,
      "checkRepTree": _vm.checkRepTree
    },
    on: {
      "onRepTreeUpdate": _vm.handleTreeUpdate
    }
  }), _c('div', {
    staticClass: "form-group mb-3 pt-3 text-center"
  }, [_c('button', {
    staticClass: "addBtn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Update Menu")])])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }